import getFlagCode from './getFlagFallbacks'

const getFlags = (code) => {
  if (code === 'XK') {
    return 'https://flagcdn.com/16x12/xk.png' // Kosovo doesn't have an official ISO code, so we use Serbia's flag as a fallback
  }
  return `https://flagsapi.com/${getFlagCode(code)}/flat/24.png`
}
export default getFlags
